export const ActionTypes = {
    TOGGLE_MENU: "TOGGLE_MENU",
    TOGGLE_LOADING: "TOGGLE_LOADING",
    SET_USER_PROFILE: "SET_USER_PROFILE",
    SHOW_ALERT: "SHOW_ALERT",
    HIDE_ALERT: "HIDE_ALERT",
    CHANGE_DISPLAY: "CHANGE_DISPLAY",
    SET_CENTER: "SET_CENTER",
    SET_CENTER_METRICS: "SET_CENTER_METRICS",
    SET_SITE: "SET_SITE",
    SET_OPO: "SET_OPO"
}